import Api from './Api'

export const ChatService = {
	getAllConvos(context) {
		return new Promise((resolve, reject) => {
			Api.get('get_all_conversations').then(response => {
				context.commit('setAllConvos', response.data);
				resolve(response.data);
			}).catch(err => {
				reject(err);
			});
		});
	},
	sendMessage(context, data) {
		return new Promise((resolve, reject) => {
			let curConvoId = data.convoId;
			if(curConvoId === null) {
				if(context.state.curConvoId !== null){
					curConvoId = context.state.curConvoId;
				} else {
					reject("No conversation id");
				}
			}
			Api.post('get_response/'+curConvoId, {query: data.query}).then(response => {
				context.commit('setCurMessages', response.data.messages);
				resolve(response);
			}).catch(err => {
				reject(err);
			})
		})
	},
	createConvo(context, data) {
		return new Promise((resolve, reject) => {
			Api.post('start_conversation', data).then(response => {
				context.commit('setCurConvoId', response.data.conversation_id);
				context.commit('setCurMessages', []);
				//debugger;
				resolve(response.data);
			}).catch(err => {
				reject(err);
			})
		});
	},
}
